// src/pages/brands/Pagination.tsx
import React from "react";
import { Pagination, PaginationItem, Button } from "@mui/material";
import arrowleft from "../../../src/assests/images/arrow_left.svg";

interface PaginationProps {
  page: number;
  limit: number;
  totalPages: number;
  setPage: (page: number) => void;
}

const PaginationReports: React.FC<PaginationProps> = ({
  page,
  limit,
  setPage,
  totalPages,
}) => {
  return (
    <div>
      <Pagination
        count={totalPages}
        page={page}
        className="pagi_nationn"
        onChange={(_, value) => setPage(value)}
        renderItem={(item) => {
          // Custom Previous button (placed inline next to page numbers)
          if (item.type === "previous") {
            return (
              <Button
                onClick={item.onClick}
                disabled={item.disabled}
                variant="contained"
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid rgba(208, 213, 221, 1)",
                  borderRadius: "8px",
                  boxShadow: "none",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#000",
                  textTransform: "capitalize",
                  opacity: item.disabled ? 0.5 : 1,
                }}
              >
                <img style={{ marginRight: 12 }} src={arrowleft} alt="Previous" />
                Previous
              </Button>
            );
          }

          // Custom Next button (placed inline next to page numbers)
          if (item.type === "next") {
            return (
              <Button
                onClick={item.onClick}
                disabled={item.disabled}
                variant="contained"
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid rgba(208, 213, 221, 1)",
                  borderRadius: "8px",
                  boxShadow: "none",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#000",
                  textTransform: "capitalize",
                  opacity: item.disabled ? 0.5 : 1,
                }}
              >
                Next
                <img
                  style={{ marginLeft: 12, transform: "rotate(180deg)" }}
                  src={arrowleft}
                  alt="Next"
                />
              </Button>
            );
          }

          // Default page number items
          return <PaginationItem {...item} />;
        }}
        sx={{
          // ✅ Keep everything centered together: Previous | 1 2 3 | Next
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px 0",
          gap: "8px",

          // Selected page styling
          ".Mui-selected": {
            backgroundColor: "rgba(245, 251, 255, 1) !important",
            borderRadius: "8px",
            color: "rgba(87, 163, 253, 1)",
            fontWeight: 500,
            ".MuiPaginationItem-text": {
              fontSize: "14px !important",
              fontWeight: 500,
            },
          },
        }}
      />
    </div>
  );
};

export default PaginationReports;
